module.exports = __webpack_public_path__ + "img/icon36.b0f7d02e.png";